import { withPrefix } from "gatsby"

import RichText from "../rich-text/renderer"
import styled, { css } from "styled-components"
import { Button as ConsistentlyButton } from "@fastly/consistently"
import { MikanSpan } from "@components/Mikan"

export const StyledCardGroup = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-bottom: 1rem;

  &:before {
    content: "";
    position: absolute;
    width: 86%;
    height: calc(100% + 14px);
    z-index: -1;
    border: ${({ borderColor }) => (borderColor ? `1px solid ${borderColor}` : `1px solid var(--grey-40)`)};
    border-radius: 16px;
    top: 1.2rem;
    max-width: 940px;

    @media (min-width: 768px) {
      width: 87%;
    }

    /* @media (min-width: 992px) {
      top: 2.5%;
    }

    @media (min-width: 1200px) {
      top: 3%;
    } */

    ${(props) =>
      props.type === "tripleCard" &&
      css`
        @media (min-width: 768px) {
          width: 92%;
        }
      `}
  }

  ${(props) =>
    props.type === "benefits" &&
    css`
      padding-bottom: 0;
      &:before {
        border: 1px solid var(--blue-light);
        border-color: ${props.borderColor ? props.borderColor : "var(--blue-light)"};
        top: inherit;
        height: calc(100% - 40px);
        bottom: -40px;
      }

      @media (min-width: 1200px) {
        flex-direction: row;

        &:before {
          width: 612px;
          align-self: flex-end;
          right: 8%;
          height: calc(100% + 80px);
        }

        & > div:nth-child(1) {
          width: 30%;
          align-self: flex-start;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
        }

        & > div:nth-child(2) {
          width: 70%;
        }
      }
    `}
`

export const StyledCardGroupIntro = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  max-width: 220px;
  margin-bottom: 40px;

  @media (min-width: 768px) {
    max-width: 1140px;
  }

  h3 {
    width: fit-content;
    background-color: white;
    padding: 0.3rem 0.5rem;
    text-align: center;

    @media (min-width: 768px) {
      width: auto;
      padding: 0 1.5rem 0.3rem;
    }
  }

  h2 {
    background-color: white;
    text-align: center;
    padding: 0.3rem 1.5rem;
  }

  p {
    text-align: center;
    width: 80%;

    @media (min-width: 768px) {
      width: 66%;
    }

    @media (min-width: 992px) {
      width: 53%;
    }
  }

  p:empty {
    display: none;
  }
`

export const StyledCardGroupPostText = styled.div`
  text-align: center;
  max-width: 190px;
  margin: 3rem 1rem 0 1rem;
  column-count: 1;

  @media (min-width: 768px) {
    max-width: 260px;
    margin: 4rem auto 0 auto;
  }
`

export const StyledCardGroupList = styled.div`
  width: 100%;
  column-count: 1;
  column-gap: 32px;
  max-width: 1140px;

  /* cards group types */
  ${(props) =>
    props.type === "tripleCard" &&
    css`
      @media (min-width: 992px) {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
      }
    `}

  ${(props) =>
    (props.type === "quadCard" || props.type === "benefits") &&
    css`
      @media (min-width: 768px) {
        column-count: 2;
      }

      @media (min-width: 1440px) {
        width: 100%;
        max-width: 1140px;
      }
    `}
`

export const StyledCardGroupItem = styled.div`
  break-inside: avoid;
  border-radius: 16px;
  background-color: ${({ cardColor }) => cardColor || `var(--grey-20)`};
  padding: 24px;

  & :nth-of-type(n + 2) {
    margin-top: 32px;
  }

  & > a:nth-of-type(2) {
    margin-left: 2rem;

    &::before {
      top: 1px;
    }
  }

  ${(props) =>
    props.className === "check-list" &&
    css`
      ul {
        list-style: none;
        padding-left: 1.5rem;

        li {
          position: relative;

          p {
            display: inline-block;
            font-weight: 500;
            margin-bottom: 0.5rem;
          }

          &::before {
            content: "✓";
            display: inline-block;
            height: 0.45rem;
            width: 0.45rem;
            color: ${(props) => (props.iconsProps.color ? `var(--${props.iconsProps.color})` : "var(grey--90)")};
            border-radius: 1rem;
            margin-left: -1.5em;
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }

      span {
        font: var(--text-sm);
      }
    `}

  ${({ type }) =>
    type === "tripleCard" &&
    css`
      display: table;

      @media (min-width: 992px) {
        & :nth-of-type(n + 2) {
          margin-top: 0;
        }
      }
    `}
`

export const StyledIcon = styled.div`
  width: ${(props) => (props.iconsProps.width ? props.iconsProps.width : "52px")};
  height: ${(props) => (props.iconsProps.height ? props.iconsProps.height : "52px")};
  margin-bottom: 1rem;
  ${(props) =>
    props.iconsProps.color
      ? css`
          mask: url("${(props) => props.src && props.src}");
          mask-size: contain;
          -webkit-mask: url("${(props) => props.src && props.src}");
          -webkit-mask-size: contain;
          background: ${(props) => (props.iconsProps.color ? `var(--${props.iconsProps.color})` : "var(grey--90)")};
          -webkit-mask-repeat: no-repeat;
        `
      : css`
          background: url("${(props) => props.src && props.src}") no-repeat;
          background-size: contain;
        `};
`

const ProductCardsGroup = ({ type, text, postText, propsValues, iconsProps, borderColor, cardColor, className }) => {
  return (
    <StyledCardGroup type={type} iconsProps={iconsProps} borderColor={borderColor}>
      {text && (
        <StyledCardGroupIntro>
          <RichText body={text.rtContent} key={text.contentful_id} mikan={text.mikan} />
        </StyledCardGroupIntro>
      )}
      <StyledCardGroupList type={type}>
        {propsValues.map((item) => (
          <StyledCardGroupItem
            type={type}
            className={className}
            iconsProps={iconsProps}
            key={item.contentful_id}
            cardColor={cardColor}
          >
            {item.media && <StyledIcon src={item.media.content.file.url} iconsProps={iconsProps}></StyledIcon>}
            <RichText body={item.content} mikan={item.mikan} />
          </StyledCardGroupItem>
        ))}
      </StyledCardGroupList>
      {postText && (
        <StyledCardGroupPostText>
          {postText.__typename === "ContentfulButton" ? (
            <ConsistentlyButton
              variant={postText.type}
              url={withPrefix(postText.url)}
              customAttributes={postText.customAttributes}
            >
              <MikanSpan text={postText.buttonText} />
            </ConsistentlyButton>
          ) : (
            <RichText body={postText.rtContent} key={postText.contentful_id} mikan={postText.mikan} />
          )}
        </StyledCardGroupPostText>
      )}
    </StyledCardGroup>
  )
}

export default ProductCardsGroup
